
export const LoginAuthAction = (auth) => (dispatch,getState)=>{
    dispatch({
        type:'LOGIN',
        payload:'akram'
    })    

}